import React, { useContext } from 'react';
import { format } from 'date-fns';
import AdminContext from '../../context/admin';

export default function EosConsumptionWidget({ consumption }) {
  const direction =
    consumption?.consumed > consumption?.baselineConsumption ? 'up' : 'down';

  let today = new Date();
  let yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const { language } = useContext(AdminContext);

  return (
    <>
      <div className="stat-title">
        {language?.eosDashboard?.consumption ?? 'Consumption'}:{' '}
        {format(yesterday, 'dd MMM - EEEE')}
      </div>
      <div className="stat-value-wrapper">
        {consumption?.consumed > 0 ? (
          <>
            <div className={`stat-value ${direction}`}>
              {consumption?.consumed.toFixed(0)} kWh
            </div>
            <div className={`stat-trend ${direction}`}>
              ({consumption?.baselineConsumption.toFixed(0)} kWh)
            </div>
          </>
        ) : (
          <div className="stat-value">N/A</div>
        )}
      </div>
    </>
  );
}
